import { showToast } from '@Sage/hoi-poi-ui';

export default {
    required: 'cfm_label_field_required',
};

const defaultErrorToastProps = {
    type: 'error',
    transition: 'slide',
    position: 'bottomLeft',
    useDefaultCloseButton: true,
    autoClose: 4000,
};

export const showErrorToast = (
    t,
    error,
    literalCustom = 'cfm_label_error_generic',
    entity = null,
) => {
    const message = error?.response?.data?.message || error?.response?.data?.error;

    const entitiesLiterals = {
        Empresas: t('cfm_label_accounts'),
        Contactos: t('cfm_label_contacts'),
        Expedientes: t('cfm_label_opportunities'),
        Gestiones: t('cfm_label_activities'),
        tblAgenda: t('cfm_label_event_task'),
        tblSalesOrders: t('cfm_label_salesorders'),
        Productos: t('cfm_label_products'),
        tblUsuarios: t('cfm_label_users'),
    };

    if (error?.response?.data?.code === 931) {
        const LANG_NAMES = {
            ES: t('cfm_label_spanish'),
            EN: t('cfm_label_en_uk'),
            US: t('cfm_label_en_us'),
            FR: t('cfm_label_fr'),
            IT: t('cfm_label_it'),
            DE: t('cfm_label_de'),
            PT: t('cfm_label_pt'),
            RU: t('cfm_label_ru'),
            DK: t('cfm_label_da'),
            BR: t('cfm_label_pt_br'),
        };

        const keys = error?.response?.data?.message.split(',').map((el) => LANG_NAMES[el]);

        showToast({
            ...defaultErrorToastProps,
            title: t('cfm_label_error_action_with_message'),
            text: t('cfm_error_duplicated_field_name', [entitiesLiterals[entity], keys.join(', ')]),
        });
    } else if (error?.response?.data?.code === 807) {
        let trimmedStr = error?.response?.data?.message.slice(1, -1); // Removes the brackets
        let entities = trimmedStr.split(', ').map((item) => item.trim());

        const replaceables = entities.reduce((arr, current) => {
            if (entitiesLiterals?.[current]) arr.push(entitiesLiterals[current]);
            return arr;
        }, []);

        showToast({
            ...defaultErrorToastProps,
            title: t('cfm_label_error_action_with_message'),
            text: t('error_table_has_dependent_fields', replaceables),
        });
    } else if (error?.response?.data?.code === 803) {
        showToast({
            ...defaultErrorToastProps,
            title: t('cfm_label_error_action_with_message'),
            text: t(message),
        });
    } else if (error?.response?.data?.code !== 901 && message) {
        showToast({
            title: t('cfm_label_error_action_with_message'),
            text: t(message),
        });
    } else if (error?.response?.data?.code !== 901 && !message) {
        showToast({
            title: t('cfm_label_error_action_with_message'),
            text: error.toString(),
        });
    } else {
        showToast({
            title: t(literalCustom),
        });
    }
};
